import React, { useEffect, useState } from 'react'
import Router from './Router'
import './App.css'
import { LocationContext } from './Components/Context/Location'
import { CartContext } from './Components/Context/CartContext';

const locationUrl = 'https://zomatourl.herokuapp.com/location';

const App = () => {
  const [locations, setLocations] = useState([])
  const [cart, setCart] = useState({})

  useEffect(() => {
    getLocation();
    const cart = window.localStorage.getItem('cart')
    setCart(JSON.parse(cart))
    // console.log(JSON.parse(cart));
  }, [])

  useEffect(() => {
    window.localStorage.setItem("cart", JSON.stringify(cart))
  }, [cart])

  const getLocation = () => {
    fetch(locationUrl, { method: "GET" })
      .then(res => res.json())
      .then(data => {
        setLocations(data)
      })
      .catch(err => {
        console.log(err);
      })
  }



  return (
    <React.Fragment>
      <CartContext.Provider value={{cart,setCart}}>
        <LocationContext.Provider value={{ locations, setLocations }} >
          <Router />
        </LocationContext.Provider>
      </CartContext.Provider>
    </React.Fragment>
  )
}

export default App